import { ReactNode } from 'react';
import { useViewEvent } from '@stitch-fix/event-reporter';
import { Grid, Box } from '@stitch-fix/mode-react';
import { CurrentLook, Lookbook } from '../graphql/types';
import GalleryItem from './GalleryItem';
import { CurrentGalleryHeader } from './CurrentGalleryHeader';
import { SupportedBusinessLine } from '../../onboarding/Onboarding';
import type { GalleryQuickActionData } from '../GalleryQuickAction';
interface CurrentGalleryProps {
  lookbook: Lookbook;
  showEmptyState?: boolean | null;
  headerContent?: ReactNode;
  isPromoTreatment?: boolean;
  businessLine?: SupportedBusinessLine;
  isShareUrlEnabled?: boolean;
  recipientCreditAmount?: string;
  galleryQuickActionModule?: GalleryQuickActionData | null;
}
const CurrentGallery = ({
  lookbook,
  showEmptyState = false,
  headerContent,
  isPromoTreatment = false,
  businessLine = 'WOMENS',
  isShareUrlEnabled = false,
  recipientCreditAmount,
  galleryQuickActionModule
}: CurrentGalleryProps) => {
  const {
    EventProvider,
    ref
  } = useViewEvent({
    schema: 'view',
    name: 'vision_current_gallery'
  });
  return <EventProvider>
      <Box ref={ref} style={{
      textAlign: 'center'
    }}>
        <CurrentGalleryHeader showEmptyState={showEmptyState} topContent={headerContent} isPromoTreatment={isPromoTreatment} businessLine={businessLine} galleryQuickActionModule={galleryQuickActionModule} />
      </Box>
      <Box px={{
      sm: 0,
      md: 1.5
    }} bgColor={{
      sm: 'white',
      md: 'gray-99'
    }} mt={1}>
        <Grid spacing="wide" columns={{
        sm: 1,
        md: 2,
        lg: 3
      }}>
          {lookbook.looks.map((look: CurrentLook) => <GalleryItem key={look.id} look={look} isShareUrlEnabled={isShareUrlEnabled} recipientCreditAmount={recipientCreditAmount} />)}
        </Grid>
      </Box>
    </EventProvider>;
};
export default CurrentGallery;